import Vue from "vue";
import VueRouter from "vue-router";
import Index from "@/components/main/index";
import { MENU } from "./menu";
import store from "@/store";
Vue.use(VueRouter);
pageVisit();

const routes = [
  {
    path: "/",
    name: "home",
    //根据用户权限重新重定向 防止资源不加载
    redirect: () => {
      return { name: "/deviceInfo-manage" };
    },
    component: Index,
    children: MENU,
  },
];
const router = new VueRouter({
  routes,
});

function pageVisit() {
  // const ShowList = JSON.parse(window.sessionStorage.getItem("ShowList")) || []
  // //所有路由的 [name] 数组
  // const allList = []
  // MENU.forEach((item) => {
  //   allList.push(item.name)
  //   item.children.forEach((i)=>{
  //     allList.push(i.name)
  //   })
  // });
  // //匹配出需要隐藏的数组储存
  // const hideList = allList.filter((item)=>{
  //   return !ShowList.includes(item);
  // })
  let hidelist = [];
  const userInfo = JSON.parse(sessionStorage.getItem('userInfo') || '{}');
  // 公共物模型和消息转发只有主账号显示
  if(userInfo?.account_type !== 1) {
    hidelist.push('/message-forwarding')
    hidelist.push('/common-physical-model')
  }


  //储存在vuex中
  store.commit("setHideMenu", hidelist);
}
// // 获取原型对象上的push函数
// const originalPush = VueRouter.prototype.push
// // 修改原型对象中的push方法
// VueRouter.prototype.push = function push(location) {
//   return originalPush.call(this, location).catch(err => err)
// }

export default router;
